import { useEffect } from "react";
import { useRouteContext } from "../lib/route-context";
import { recordVisit } from "../lib/journey";
import { markFeatureTried } from "../lib/settings";

// Route-reachable features for the Your-journey checklist, marked as the visitor navigates.
const NODE_FEATURE: Record<string, string> = {
  experience: "open-experience",
  project: "open-engagement",
  lens: "lens",
  graph: "graph",
  print: "print",
};

export function VisitTracker() {
  const ctx = useRouteContext();
  useEffect(() => {
    void recordVisit({
      path: ctx.path,
      title: ctx.title,
      nodeType: ctx.nodeType,
      nodeId: ctx.nodeId,
      filters: ctx.filters,
    });
    const feat = NODE_FEATURE[ctx.nodeType];
    if (feat) void markFeatureTried(feat);
    if (ctx.path === "/app") void markFeatureTried("about");
  }, [ctx.path, ctx.title, ctx.nodeType, ctx.nodeId, ctx.filters]);
  return null;
}
